import { render, staticRenderFns } from "./getOrder.vue?vue&type=template&id=55c90859&scoped=true&"
import script from "./getOrder.vue?vue&type=script&lang=js&"
export * from "./getOrder.vue?vue&type=script&lang=js&"
import style0 from "./getOrder.vue?vue&type=style&index=0&id=55c90859&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c90859",
  null
  
)

export default component.exports